import React, { ReactElement } from 'react'
import { useNavigate } from 'react-router-dom'

import CustomButton from 'components/elements/buttons/CustomButton'
import { Check as CheckIcon } from '../../../icons'
import PlanStatus from 'components/elements/blocks/PlanStatus'

import styles from './ProductCard.module.scss'
import { SubscriptionStatus } from 'models/user'
import { logAmplitudeEvent } from 'utils/analytics'

export interface IProduct {
  title: string
  description: string | JSX.Element
  link: string
  icon: ReactElement
  features?: string[] | JSX.Element[]
  status: SubscriptionStatus
  btnLabel: string
}

interface IPricingProductCardProps {
  product: IProduct
  isDemoModeAvailable: boolean
  isFullFunctional?: boolean
  className?: string
}

const ProductCard: React.FC<IPricingProductCardProps> = (props) => {
  const { product, className, isDemoModeAvailable, isFullFunctional } = props
  const navigate = useNavigate()

  const featuresList = product.features?.map((feature, index) => {
    return (
      <div
        className={styles.feature}
        key={`pricing-product-${product.title}-card-feature_${index}`}
      >
        <div className={styles.featureIcon}>
          <CheckIcon />
        </div>
        <div>{feature}</div>
      </div>
    )
  })

  const handleBtnClick = () => {
    navigate(product.link)
  }

  const handlePreviewClick = () => {
    logAmplitudeEvent(`Preview ${product.title} product click`)

    handleBtnClick()
  }

  const handleNavigateToPricing = () => {
    navigate('/pricing')
  }

  const getStatus = () => {
    if (isDemoModeAvailable) {
      return 'demo'
    } else {
      return null
    }
  }

  const renderBtn = () => {
    if (isFullFunctional) {
      return (
        <CustomButton onClick={handleBtnClick} wide className={styles.cardBtn}>
          {`Use ${product.btnLabel}`}
        </CustomButton>
      )
    } else if (isDemoModeAvailable) {
      return (
        <CustomButton onClick={handlePreviewClick} color={'outline'} wide className={styles.cardBtn}>
          {`Preview ${product.btnLabel}`}
        </CustomButton>
      )
    } else {
      return (
        <CustomButton onClick={handleBtnClick} wide disabled className={styles.cardBtn}>
          {`Use ${product.btnLabel}`}
        </CustomButton>
      )
    }
  }

  return (
    <div
      className={`
        ${styles.card}
        ${className || ''}
      `}
    >
      <div className={styles.header}>
        <div className={styles.productIconWrapper}>{product.icon}</div>
        <div className={styles.title}>{product.title}</div>

        <PlanStatus className={styles.status} status={getStatus()} />
      </div>

      <div className={styles.description}>{product.description}</div>

      <div className={styles.featuresList}>{featuresList}</div>

      {renderBtn()}

      {isDemoModeAvailable && (
        <div className={styles.pricingBtnWrapper}>
          <CustomButton color={'ghostAlt'} onClick={handleNavigateToPricing}>
            Choose plan to activate
          </CustomButton>
        </div>
      )}
    </div>
  )
}

export default ProductCard
